import { FC, useEffect, useState } from "react";
import { Box, FormLabel, Grid, GridItem, HStack, Heading, VStack } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { EnvironmentSelect } from "../components/EnvironmentSelect";
import { useSearchParams } from "react-router-dom";
import { TimeseriesLineChart } from "../components/TimeseriesLineChart";
import { TimeseriesBarChart } from "../components/TimeseriesBarChart";
import { TimeseriesStackedBarChart } from "../components/TimeseriesStackedBarChart";
import { PromptNameSelect } from "../components/PromptSelect";


const FeedbackOverviewPage: FC = () => {

    const [pageLoaded, setPageLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedEnvironment, setSelectedEnvironment] = useState<string>(searchParams.get("environment") ?? "all");
    const [selectedPromptName, setSelectedPromptName] = useState<string>(searchParams.get("prompt-name") ?? "all");


    // Delay rendering until the component is mounted.
    // Otherwise our charts grow way past their Card containers.
    useEffect(() => {
        setPageLoaded(true);
    }, []);

    // This will be null until the component is mounted,
    // so that our charts don't grow past their Card containers.
    if (!pageLoaded) {
        return null;
    }

    const handleEnvironmentChange = (env: string) => {
        setSelectedEnvironment(env);
        setSearchParams({ environment: env })
    }

    const handlePromptNameChange = (promptName: string) => {
        setSelectedPromptName(promptName);
        setSearchParams({ promptName: promptName })
    }

    return (
        <VStack align={"start"}>
            <HStack justifyContent={"space-between"} w={"full"}>
                <Heading size='sm'>Feedback Overview</Heading>
                <HStack>
                    <PromptNameSelect defaultPromptName={searchParams.get("promptName")} onChange={handlePromptNameChange} />
                    <EnvironmentSelect defaultEnvironment={searchParams.get("environment")} onChange={handleEnvironmentChange} />
                    <Box>
                        <FormLabel fontSize="xs" fontWeight="medium" mb={0}>Timeframe</FormLabel>
                        <Select
                            defaultValue={{ label: "Past 24 hours", value: "Past 24 hours" }}
                            options={[{
                                label: "Past 24 hours",
                                value: "Past 24 hours"
                            }]}
                            size="sm"
                            chakraStyles={{
                                container: (provided) => ({
                                    ...provided,
                                    w: "200px"
                                }),
                            }}
                            isDisabled
                        />
                    </Box>
                </HStack>
            </HStack>
            <Grid templateColumns='repeat(4, 1fr)' gap={6} w={"full"}>
                <GridItem rowSpan={1} colSpan={4} minWidth="400px">
                    <TimeseriesBarChart
                        timeseriesQuery="user-count"
                        environment={selectedEnvironment}
                        promptName={selectedPromptName}
                        chartName={"Users"}
                        chartDescription={"Number of unique users over time."} />
                </GridItem>
                <GridItem rowSpan={1} colSpan={2} minWidth="400px">
                    <TimeseriesLineChart
                        timeseriesQuery="journey-failure-rate"
                        environment={selectedEnvironment}
                        promptName={selectedPromptName}
                        chartName={"% Journeys with Errors"}
                        chartDescription={"Success / fail over time."}
                        lineColor="#F56565" />
                </GridItem>
                <GridItem rowSpan={1} colSpan={2} minWidth="400px" >
                    <TimeseriesStackedBarChart
                        timeseriesQuery="user-feedback-count-by-nps"
                        environment={selectedEnvironment}
                        promptName={selectedPromptName}
                        chartName={"User Feedback"}
                        chartDescription={"User feedback scores over time (treated as NPS)."} />
                </GridItem>
                <GridItem rowSpan={1} colSpan={2} minWidth="400px">
                    <TimeseriesLineChart
                        timeseriesQuery="unknown-function-percent"
                        environment={selectedEnvironment}
                        promptName={selectedPromptName}
                        chartName={"% UNKNOWN"}
                        lineColor="#F56565" />
                </GridItem>
                <GridItem rowSpan={1} colSpan={2} minWidth="400px">
                    {/* <TimeseriesLineChart timeseriesQuery="journey-failure-rate" environment={selectedEnvironment} chartName={"% Journeys with Errors"} chartDescription={"Success / fail over time."} lineColor="#F56565" /> */}
                </GridItem>
                <GridItem rowSpan={1} colSpan={4} minWidth="400px">
                    {/* <TimeseriesLineChart timeseriesQuery="journey-failure-rate" environment={selectedEnvironment} chartName={"% Journeys with Errors"} chartDescription={"Success / fail over time."} lineColor="#F56565" /> */}
                </GridItem>

            </Grid>
        </VStack>
    );
};

export default FeedbackOverviewPage;
